<app-main-container header="Documentos físicos de libranza"
  subheader="Descarga y carga los documentos de libranza firmados por el solicitante">
  <app-file-upload-physical-docs [rules]="rules" [title]="title" [subtitle]="subtitle" [contract]="contract" [secuencia]="secuencia" [idFolder]="idFolder" [identificacion]="identificacion" [nombreArchivoFinal]="nombreArchivoFinal" (finalizaCarga)="cambiarEstado()"></app-file-upload-physical-docs>
</app-main-container>
